import { useCallback } from 'react'

import { createImageEvent } from '@/events'
import { TrackImageInput } from '@/types'

import { useAnalytics } from './AnalyticsHook'

export const useImageHook = (brand: string) => {
  const analytics = useAnalytics()

  const trackImageEvent = useCallback(
    (data: TrackImageInput) => {
      const event = createImageEvent(brand, data)
      analytics.trackEvent(event)
    },
    [analytics, brand]
  )
  
  return trackImageEvent
}
